import { Button } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import AddModal from "../../pages/leads/pages/company-submission/components/modal/add-modal";

function CompanyCard() {
  // STATES
  const [createModalPreview, setCreateModalPreview] = useState(false);

  // REDUX DATA
  const { profile } = useSelector((state) => state.UserReducer);

  return (
    <div className="company-required">
      <h2>Company required</h2>
      <p>
        Please create a company to access this feature. You can create a company by
        clicking the button below.
      </p>
      <Button
        type="primary"
        onClick={() => setCreateModalPreview(true)}
      >
        Create company
      </Button>
      <AddModal
        show={createModalPreview}
        onClose={() => setCreateModalPreview(false)}
        isOrganization={profile.organization}
      />
    </div>
  );
}

export default CompanyCard;
